/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubtaskUpdate
 */
export interface SubtaskUpdate {
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof SubtaskUpdate
     */
    kwargs: { [key: string]: string | undefined; };
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof SubtaskUpdate
     */
    graphLayout?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {string}
     * @memberof SubtaskUpdate
     */
    trigger?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubtaskUpdate
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubtaskUpdate
     */
    noopDontSave?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubtaskUpdate
     */
    noConcurrency?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubtaskUpdate
     */
    timeout?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubtaskUpdate
     */
    logVariable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubtaskUpdate
     */
    task?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubtaskUpdate
     */
    conditionVariable?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubtaskUpdate
     */
    conditionValue?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubtaskUpdate
     */
    sync?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubtaskUpdate
     */
    queue?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubtaskUpdate
     */
    enqueueAtFront?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubtaskUpdate
     */
    parent: number;
    /**
     * 
     * @type {number}
     * @memberof SubtaskUpdate
     */
    relativeTo?: number | null;
}

export function SubtaskUpdateFromJSON(json: any): SubtaskUpdate {
    return SubtaskUpdateFromJSONTyped(json, false);
}

export function SubtaskUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubtaskUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'kwargs': json['kwargs'],
        'graphLayout': !exists(json, 'graph_layout') ? undefined : json['graph_layout'],
        'trigger': !exists(json, 'trigger') ? undefined : json['trigger'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'noopDontSave': !exists(json, 'noop_dont_save') ? undefined : json['noop_dont_save'],
        'noConcurrency': !exists(json, 'no_concurrency') ? undefined : json['no_concurrency'],
        'timeout': !exists(json, 'timeout') ? undefined : json['timeout'],
        'logVariable': !exists(json, 'log_variable') ? undefined : json['log_variable'],
        'task': !exists(json, 'task') ? undefined : json['task'],
        'conditionVariable': !exists(json, 'condition_variable') ? undefined : json['condition_variable'],
        'conditionValue': !exists(json, 'condition_value') ? undefined : json['condition_value'],
        'sync': !exists(json, 'sync') ? undefined : json['sync'],
        'queue': !exists(json, 'queue') ? undefined : json['queue'],
        'enqueueAtFront': !exists(json, 'enqueue_at_front') ? undefined : json['enqueue_at_front'],
        'parent': json['parent'],
        'relativeTo': !exists(json, 'relative_to') ? undefined : json['relative_to'],
    };
}

export function SubtaskUpdateToJSON(value?: SubtaskUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'kwargs': value.kwargs,
        'graph_layout': value.graphLayout,
        'trigger': value.trigger,
        'name': value.name,
        'noop_dont_save': value.noopDontSave,
        'no_concurrency': value.noConcurrency,
        'timeout': value.timeout,
        'log_variable': value.logVariable,
        'task': value.task,
        'condition_variable': value.conditionVariable,
        'condition_value': value.conditionValue,
        'sync': value.sync,
        'queue': value.queue,
        'enqueue_at_front': value.enqueueAtFront,
        'parent': value.parent,
        'relative_to': value.relativeTo,
    };
}


